function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

export { _isString as default };
